/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Partner,
  PartnerNew,
} from '../models/index';
import {
    PartnerFromJSON,
    PartnerToJSON,
    PartnerNewFromJSON,
    PartnerNewToJSON,
} from '../models/index';

export interface CreatePartnerRequest {
    partnerNew: PartnerNew;
}

export interface UpdatePartnerRequest {
    partnerId: number;
    partnerNew: PartnerNew;
}

/**
 * 
 */
export class PartnersApi extends runtime.BaseAPI {

    /**
     */
    async createPartnerRaw(requestParameters: CreatePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Partner>> {
        if (requestParameters['partnerNew'] == null) {
            throw new runtime.RequiredError(
                'partnerNew',
                'Required parameter "partnerNew" was null or undefined when calling createPartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/partners`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerNewToJSON(requestParameters['partnerNew']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartnerFromJSON(jsonValue));
    }

    /**
     */
    async createPartner(requestParameters: CreatePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Partner> {
        const response = await this.createPartnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPartnersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Partner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/partners`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartnerFromJSON));
    }

    /**
     */
    async getPartners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Partner>> {
        const response = await this.getPartnersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updatePartnerRaw(requestParameters: UpdatePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling updatePartner().'
            );
        }

        if (requestParameters['partnerNew'] == null) {
            throw new runtime.RequiredError(
                'partnerNew',
                'Required parameter "partnerNew" was null or undefined when calling updatePartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/partners/{partnerId}`;
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartnerNewToJSON(requestParameters['partnerNew']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePartner(requestParameters: UpdatePartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePartnerRaw(requestParameters, initOverrides);
    }

}
